import styled from 'styled-components';

export const NavbarContainer = styled.nav`
	display: flex;
	margin-top: 15px;
	gap: 2em;
`;
